(function () {
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

hubspot.define('hubspot.ErrorPageMixer.mixer', ['jQuery', 'hubspot.PortalIdParser'], function($, PortalIdParser) {
  var ErrorPage, defaults;
  defaults = function() {
    return {
      mainContainer: 'body .page',
      400: {
        title: I18n.text('400.title'),
        subtitle: I18n.text('400.subtitle'),
        error_message: I18n.text('400.error_message'),
        link_href: '#',
        link_onclick: "history.go(-1); return true;",
        link_text: I18n.text('400.link_text')
      },
      404: {
        title: I18n.text('404.title'),
        error_message: I18n.text('404.error_message'),
        link_href: "/dashboard/" + (PortalIdParser.get({
          preserveGlobalId: true
        })),
        link_text: I18n.text('404.link_text')
      },
      410: {
        title: I18n.text('410.title'),
        subtitle: I18n.text('410.subtitle'),
        error_message: I18n.text('410.error_message'),
        link_href: "/dashboard/" + (PortalIdParser.get({
          preserveGlobalId: true
        })),
        link_text: I18n.text('410.link_text')
      },
      500: {
        title: I18n.text('500.title'),
        subtitle: I18n.text('500.subtitle'),
        error_message: I18n.text('500.error_message'),
        link_href: "#",
        link_onclick: "history.go(-1); return true;",
        link_text: I18n.text('500.link_text')
      }
    };
  };
  return ErrorPage = (function() {
    function ErrorPage() {
      this.hideErrorPage = bind(this.hideErrorPage, this);
      this.showErrorPage = bind(this.showErrorPage, this);
    }

    ErrorPage.prototype.showErrorPage = function(code, opts) {
      var errorConfig, onclick, ref, useCallback;
      if (opts == null) {
        opts = {};
      }
      if (!this.errorPageShown) {
        this.errorPageDefaults = $.extend(true, defaults(), this.errorPageDefaults);
        errorConfig = $.extend(true, {}, this.errorPageDefaults[code] || this.errorPageDefaults['500'], opts);
        onclick = errorConfig.link_onclick;
        if ($.isFunction(onclick)) {
          useCallback = true;
          delete errorConfig.link_onclick;
        }
        $(this.errorPageDefaults.mainContainer).hide();
        $('body footer').hide();
        $('html').addClass("app-error-page").attr('data-error', "" + code);
        $('head').append($(jade.templates['style']()));
        $('body').append($(jade.templates['error'](errorConfig)));
        if (useCallback) {
          $('#content > a').on('click', onclick);
        }
        Backbone.history.on('route', this.hideErrorPage);
        document.title = "HubSpot - " + ((ref = errorConfig.subtitle) != null ? ref : errorConfig.title);
        return this.errorPageShown = true;
      }
    };

    ErrorPage.prototype.hideErrorPage = function() {
      if (this.errorPageShown) {
        $('.app-error-page .app-error-container').remove();
        $('html').removeClass('app-error-page');
        $(this.errorPageDefaults.mainContainer).show();
        $('body footer').show();
        Backbone.history.off('route', this.hideErrorPage);
        return this.errorPageShown = false;
      }
    };

    return ErrorPage;

  })();
});
}());

